import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-reports-group-search',
  templateUrl: './reports-group-search.component.html',
  styleUrls: ['./reports-group-search.component.scss']
})
export class ReportsGroupSearchComponent implements OnInit {
  public name: string = '';
  public id: string = '';
  public nameLabel: string = '';
  public idLabel: string = '';
  public searchLabel: string = '';
  @Output() onSearch: EventEmitter<any> = new EventEmitter(null);

  constructor() { }

  ngOnInit() {
    this.initializeLabel();
  }

  public find() {
    var pname = this.name == '' ? null : this.name;
    var pid = this.id == '' ? null : this.id;

    this.onSearch.emit({ name: pname, id: pid });
  }

  public resetSearchFilters() {
    this.name = '';
    this.id = '';
  }

  public initializeLabel() {
      this.nameLabel = "Group Name";
      this.idLabel = "Group ID";
      this.searchLabel = "Search Group";
  }

  public get disableName(): boolean {
    return (this.id.trim() != '')
  }
  public get disableId(): boolean {
    return (this.name.trim() != '')
  }

  public setLabel(name: string, id: string, search: string ){
    this.nameLabel = name;
    this.idLabel = id;
    this.searchLabel = search;
  }
}
